$(document).on 'click', 'button.clone_assessment_dialog', (ev)->
  ev.preventDefault()
  the_link = $(this)
  invite = ->
    $.ajax({
      url: the_link.data('invite'),
      dataType: 'script',
      type: "POST",
      cache: false
    })

  if the_link.hasClass('invite')
    invite()
  else if $(this).hasClass('resend-all')
    $.ajax({
      url: the_link.data('reset'),
      type: "DELETE",
      cache: false,
      success: ->
        invite()
    })

  return false
